module.exports = __webpack_public_path__ + "static/media/Doc.6ba9c76a.png";